module.exports = __webpack_public_path__ + "img/baby5.261ddebb.png";